import {connect} from 'react-redux';

import {QCManagerState} from './QCManagerTypes';
import QCManagerContainer from './QCManagerContainer';
import {
    exportQCJobsAction,
    setQCJobsListAction,
    resetQCJobsListAction,
    assignQCJobAction,
    unassignQCJobAction,
    changeQCJobPriorityAction,
    getQCJobsSummaryAction,
    setQcJobDueDateAction,
} from './Redux/QCManagerActions';
import {setNotificationAction} from '../../@pluto/notification';

export type QCState = {qcManager: QCManagerState};

export const mapState = (state: QCState): QCState => {
    const {qcManager} = state;

    return {
        qcManager,
    };
};

export const mapDispatch = {
    setQcJobDueDate: setQcJobDueDateAction,
    setQCJobs: setQCJobsListAction,
    exportQCJobs: exportQCJobsAction,
    resetQCJobs: resetQCJobsListAction,
    changeQCJobPriority: changeQCJobPriorityAction,
    assignQCJob: assignQCJobAction,
    unassignQCJob: unassignQCJobAction,
    getQCJobsSummary: getQCJobsSummaryAction,
    setNotification: setNotificationAction,
};

export default connect(mapState, mapDispatch as any)(QCManagerContainer);
